import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import CallCard from "@/components/CallCard";
import { Users } from "lucide-react";

export default function Following() {
  const { user, loading } = useAuth();
  const [calls, setCalls] = useState(null);

  useEffect(() => {
    if (!user) return;
    api.get("/following/feed").then(({ data }) => setCalls(data)).catch(() => setCalls([]));
  }, [user]);

  if (loading) return null;
  if (!user) return <div className="max-w-lg mx-auto px-4 py-24 text-center"><p className="font-display text-2xl font-bold">Sign in to see your Following feed</p></div>;

  return (
    <div className="max-w-2xl mx-auto px-4 py-8">
      <h1 className="font-display text-3xl font-bold mb-4 flex items-center gap-2"><Users className="w-6 h-6" /> Following</h1>
      <div className="space-y-5">
        {calls?.map((c) => <CallCard key={c.short_id} call={c} />)}
        {calls && calls.length === 0 && <p className="text-center text-muted-foreground py-12">Follow some callers to fill this feed.</p>}
      </div>
    </div>
  );
}
